module.exports = __webpack_public_path__ + "media/icons/chevron-left-29f7b55a1a74d8af1d00fab8d4554018.svg";